import React from 'react';
import styled from 'styled-components';

const StyledSpan = styled.span`
  @font-face {
    font-family: 'Material Symbols Outlined';
    font-style: normal;
    font-weight: 100 700;
    src: url("https://fonts.gstatic.com/s/materialsymbolsoutlined/v57/kJEhBvYX7BgnkSrUwT8OhrdQw4oELdPIeeII9v6oFsLjBuVY.woff2") format('woff2');
 }

  display: inline-block;
  padding-left: 2px;
  font-family: "Material Symbols Outlined", sans-serif;
  font-size: 0.875rem;
  font-style: normal;
  font-weight: normal;
  font-feature-settings: 'liga';
  line-height: 1.5715;
  text-transform: none;
  letter-spacing: normal;
  word-wrap: normal;
  white-space: nowrap;
  direction: ltr;
  -webkit-font-smoothing: antialiased;
`;

export default function OpenInNewIcon() {
    return <StyledSpan className="open-in-new-span">open_in_new</StyledSpan>;
}
